import moment from "moment-timezone";
import { translate } from '@td/shared_utils';
import { TASK_DATE_FORMAT } from "../constants";

export const formatTaskDate = date => moment(date).format(TASK_DATE_FORMAT)
export const mapChecklistItemToOption = item => ({ completed: false, text: item });

export const mapCategoryToOption = category => {
  if (category) {
    return {
      value: category,
      label: translate(null, 'care_team_tasks.categories', category.replace('TASKCATEGORY_', ''))
    };
  } else {
    return null;
  }
};
